// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"13":"80df455f","348":"217e1099","361":"f8a0f8a7","541":"668c07b3","723":"7bdff6b7","862":"92c68efd","961":"bb2d7fb1"}[chunkId] + ".chunk.js";
};